import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ZuiDocsTextModule } from '@zerops/zui/docs-text';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { ErrorsPrinterComponent } from './errors-printer.component';

@NgModule({
  declarations: [ ErrorsPrinterComponent ],
  imports: [
    CommonModule,
    MatIconModule,
    ZuiDocsTextModule,
    ZuiSeparatorComponent
  ],
  exports: [ ErrorsPrinterComponent ]
})
export class ZuiErrorsPrinterModule {}
